import { translate } from "react-admin";
import PropTypes from "prop-types";

const TranslatedText = ({ translate, resource_name }) =>
    translate(resource_name);

TranslatedText.propTypes = {
    resource_name: PropTypes.string.isRequired
};

export default translate(TranslatedText);



// WEBPACK FOOTER //
// ./src/components/TranslatedText.js